module.exports = __webpack_public_path__ + "static/media/VisitPITTSBURGH_poster_2.aeae64bd.jpg";